<template>
  <div id="product-data-wrap" :class="['product-data-wrap']" v-loading="loading || in_sideLoading">

    <header class="top">
      <div class="left">
        <el-button v-for="(item, k) in statusList" :key="k" :type="item.is_selected ? 'normal' : 'text'"
          @click="pickStatus(k)">
          {{ item.text }}
        </el-button>
      </div>
      <div class="ui-search">
        <Search @onenter="search" :placeholder_text="`Search`"/>
      </div>
      <div class="right">
        <Dropdown :items="select_pagenum" :disabled="is_empty_data" @update-dropdown="updatePagenum" />
        <Pagenavi :disabled="is_empty_data" :page_current="sort.current_page" :page_total="sort.total_page" @goto-page="gotoPage" />
        <RowEditList :data="productData" :type="'product'">
          <el-button type="primary" :disabled="productData.every(e => { return !e.checked })">Edit</el-button>
        </RowEditList>
      </div>
    </header>

    <Scrollbar
      :class="['data-list', (editValue && now_pick_key < 7 && productData.length <= 5) && 'data-list-open-scroll']"
      :show_bar="true">
      <Table :style="'--top: 0px'">
        <template #head>
          <tr>
            <th @click="toggleAll">
              <Checkbox :checked="checkAll" />
            </th>
            <th class="name-row"><span>Products</span></th>
            <th><span>Status</span></th>
            <th><span>Variants</span></th>
            <th><span>Recipients</span></th>
            <th><span>Collections</span></th>
            <TableTh style="min-width: 100px;" :name="'created_at'" :title="'Added'" :sort_value="sort" @sort="sortFun"
              :content="'Date Added'" />
            <th class="svg-th"><span>Actions</span></th>
          </tr>
        </template>

        <template #body>
          <template v-if="productData.length === 0">
            <tr>
              <td colspan="7">
                <NoData />
              </td>
            </tr>
          </template>
          <!-- A single product may have multiple items, so take the first one (index 0). -->
          <tr v-else v-for="(row, index) in productData" :key="index">
            <td @click="checkHandle(row, index)">
              <Checkbox :disabled="row.status.code === 0" :checked="row.checked" />
            </td>

            <td class="title">
              <div class="title-content">

                <figure class="img-box img-box-white" v-if="row.product_data.images">
                  <img class="likeboard-layout-wrap" :src="row.product_data.images.img_200x200" :alt="row.name"
                    @error="imageError($event)" />
                </figure>

                <div class="middle">
                  <div class="collect-name-box">
                    <div class="collect-name" v-tippy="{ content: row.product_data.name, delay: [500, 20] }">
                      {{ row.product_data.name }}
                    </div>
                    <div class="desc" v-tippy="{ content: row.brand, delay: [500, 20] }">{{ row.product_data.brand_name
                      }}</div>
                  </div>

                  <div class="bottom">
                    ${{ row.product_data.price }}
                  </div>
                </div>
              </div>
            </td>

            <td class="status-td">
              <div class="flex">
                <Badage :value="row.statusBag.label" :type="row.statusBag.color" />
                <Badage v-if="row.is_feature && row.status!== STATUS_CODE.Draft && row.status!== STATUS_CODE.Scheduled" value="Featured" type="yellow" />
              </div>
              <div class="date">
                Published: {{ moment(row.updated_at).format('MMM DD, YYYY') }}
              </div>
              <div class="date" v-if="(row.disable_datetime || row.status == STATUS_CODE.Disabled) && row.status!== STATUS_CODE.Draft">
                {{ row.status == STATUS_CODE.Disabled ? 'Disabled': 'End Date' }}: {{ row.status == STATUS_CODE.Disabled && row.disabled_at ?  moment(row.disabled_at).format('MMM DD, YYYY') : row.disable_datetime ?  moment(row.disable_datetime).format('MMM DD, YYYY'):'---' }}
              </div>
            </td>

            <td class="variants-td">
              <span v-if="row.total_color_size_map.filter(v => v.is_added_in_storefront).length === 0">---</span>
              <span v-else v-for="item in row.total_color_size_map.filter(v => v.is_added_in_storefront)" :key="item.id">
                {{ 
                  item.color ? item.color : '' 
                }} 
                {{ 
                  item.color && item.size ? '/' : '' 
                }}
                {{
                  item.size ? item.size : ''
                }}
              </span>
            </td>

            <td>
              <span class="rec-td">
                <span class="small-badage">
                  <svg-icon name="users-2" />
                  {{ row.recipient_count }}
                </span>
                <svg-icon name="pen" @click="openPostTo(row)" />
              </span>
            </td>

            <td>
              <span class="coll-td">
                {{ row.curation_collection_count}}
                <svg-icon name="arrow" @click="openBook(row)" />
              </span>
            </td>

            <td>
              <span class="user-name">{{ row.creator_name }}</span>
              <div class="date-text" v-html="formatDate(row.created_at)"></div>
            </td>

            <td class="menu-td" @click.stop="pickEdit(row, index)">
              <span class="svg-td"><svg-icon name="menu" /></span>
              <div class="editList" v-if="editValue && now_pick_row.id === row.id" :style="editListTopText" ref="el">
                <div class="item" v-for="(item, index) in editList" :key="index"
                  @click.stop="selectType(item.id, index)">
                  <span :class="[item.id === 9 && 'red']">{{ item.text }}</span>
                </div>
              </div>
            </td>
          </tr>
        </template>
      </Table>
    </Scrollbar>


  </div>

  <EditProductVariants ref="edit_product_variants_el" :is_edit_mode="true" :tagged_products="productData" />

</template>

<script setup>
import { ref, onMounted, getCurrentInstance, computed, onBeforeUnmount } from 'vue';
import { ElButton } from 'element-plus';
import { useStore } from 'vuex';
import moment from 'moment';
import Table from '@/components/ui/Table.vue';
import NoData from '@/components/creator/NoData.vue';
import Scrollbar from '@/components/ui/Scrollbar.vue';
import Checkbox from '@/components/ui/Checkbox.vue';
import TableTh from '@/components/ui/TableTh.vue';
import Badage from '@/components/ui/Badage.vue';
import Search from '@/components/ui/Search.vue';
import Pagenavi from '@/components/ui/Pagenavi.vue';
import Dropdown from '@/components/ui/Dropdown.vue';
import { ImageError } from '@/utils/SwitchFun';
import { useStorefrontFunction } from '@/components/storefront/StorefrontFunction.js';
import RowEditList from './RowEditList.vue';
import EditProductVariants from '../tag/SelectProductVariants.vue';

const emit = defineEmits(['isProductEmpty'])
const app = getCurrentInstance();
const ajax = app.appContext.config.globalProperties.$ajax;
const eventBus = app.appContext.config.globalProperties.EventBus;
const store = useStore();
const { openRecipientEditDialog, STATUS_CODE, handleStatus, in_sideLoading, saveRecipitentInTable } = useStorefrontFunction();
const loading = ref(false);
const productData = ref([]);
const edit_product_variants_el = ref(null);

const select_pagenum = ref([
  { id: 50, text: '50/page' },
  { id: 20, text: '20/page' },
]);
const sort = ref({
  sort_key: 'created_at',
  sort_val: 'desc',
  page: 1,
  per_page: 50,
  search_keyword: '',
  current_page: 1,
  total_page: 1,
});
const params = ref({
  status: '',
  tag: [],
});
const checkAll = ref(false);
const statusList = ref([
  { id: null, text: 'All', is_selected: true, keyword: '', },
  { id: STATUS_CODE.Active, text: 'Active', is_selected: false, keyword: 'active', },
  { id: STATUS_CODE.Draft, text: 'Draft', is_selected: false, keyword: 'draft', },
  { id: STATUS_CODE.Scheduled, text: 'Scheduled', is_selected: false, keyword: 'schedule', },
  { id: STATUS_CODE.Disabled, text: 'Disabled', is_selected: false, keyword: 'disable', },
]);
const is_empty_data = computed(() => {
  return productData.value.length === 0;
});

const DROP_LIST = {
  Edit: { id: 1, text: 'Edit info' },
  Feature: { id: 2, text: 'Feature' },
  Disabled: { id: 6, text: 'Disable' },
  UnFeature: { id: 7, text: 'Unfeature' },
  Publish: { id: 8, text: 'Publish' },
  Delete: { id: 9, text: 'Delete' },
  ReActive: { id: 10, text: 'Reactivate' },
};

const editList = ref([]);
const editValue = ref(false);
const now_pick_key = ref(null);
const now_pick_row = ref(null);
const el = ref(null);
const all_product_rows = ref([]); // save all products
//handle edit list dropdown style
const editListTop = ref(0);
const editListTopText = ref('');


//+++++++++++++++++++++++++
const imageError = ImageError;

const formatDate = (dateStr) => {
  if (!dateStr) return null;
  return `${moment(dateStr).format('MMM DD, YYYY')}<br />${moment(dateStr).format('hh:mm A UTC')} `;
};

const makeApiStr = () => {
  let filters = [];

  if (params.value.status) {
    filters.push({ "field_name": 'status', "value": params.value.status })
  }

  return JSON.stringify(filters);
};

const canClickItem = (val) => {
  const hasAny = true;//(val.status=== STATUS_CODE.Draft && val.is_sponsored_disclosure_enabled )|| val.status !== STATUS_CODE.Draft

  return hasAny;
};


const fetchData = async () => {

  const params_data = {
    sort_key: sort.value.sort_key,//created_at
    sort_val: sort.value.sort_val,
    page: sort.value.page,
    per_page: sort.value.per_page,
    filters: makeApiStr(),
    keyword: sort.value.search_keyword,
  };
  try {
    loading.value = true;
    const res = await ajax(`storefront-curation/get-curation-product-list`, {
      params: params_data,
      method: 'get',
    });


    res.data.data.data.forEach(item => {
      handleStatus(item);
      item.product_data = item.products[0] || {};
      item.canClick = canClickItem(item);
      item.canDisable = item.status === STATUS_CODE.Active;
      
      // Process data for edit functionality
      let creator_ids = Array.isArray(item.recipient_creators)
        ? item.recipient_creators
        : [];

      let group_ids = item.recipient_groups
        ? item.recipient_groups
        : [];

      if (item.apply_to_all_creators) {
        item.post_to = { type: 'all', data: [{ name: 'All' }] };
        item.click_all = true;
      } else {
        item.post_to = { type: 'pick', data: [...creator_ids, ...group_ids] };
        item.click_all = false;
      }

      if (item.disable_datetime) {
        item.scheduled_end_enabled = 1;
        item.scheduled_end = { 
          date: moment(item.disable_datetime).format('MM/DD/YYYY'),
          time: moment(item.disable_datetime).format('h:mm A'),
          val: item.disable_datetime
        };
      } else {
        item.scheduled_end_enabled = 0;
        item.scheduled_end = { 
          date: '',
          time: '',
          val: ''
        };
      }

      if (item.publish_datetime) {
        item.scheduled_start_enabled = 1;
        item.scheduled_start = { 
          date: moment(item.publish_datetime).format('MM/DD/YYYY'),
          time: moment(item.publish_datetime).format('h:mm A'),
          val: item.publish_datetime
        };
      } else {
        item.scheduled_start_enabled = 0;
        item.scheduled_start = { 
          date: '',
          time: '',
          val: ''
        };
      }

      item.name = item.product_data.name;
      item.images = item.product_data.images;
      // item.collections = item.curation_collections || [];
      item.notify_creators = item.notify_creator_on_publish;
      item.permission = [];

      if (item.total_color_size_map && item.total_color_size_map.length > 0) {
        item.unique_color_list = [];
        item.unique_size_list = [];
        item.total_color_size_map.forEach(variant => {
          if (variant.color && !item.unique_color_list.includes(variant.color)) {
            item.unique_color_list.push(variant.color);
          }

          if (variant.size && !item.unique_size_list.includes(variant.size)) {
            item.unique_size_list.push(variant.size);
          }

          item.unique_size_count = item.unique_size_list.length;
          item.unique_color_count = item.unique_color_list.length;
        });
      }

      if (item.is_feature) {
        item.permission.push('allow_feature');
      }
      
      if (item.allow_creator_remove) {
        item.permission.push('allow_remove');
      }
      

      item.is_draft = item.status === STATUS_CODE.Draft;
      item.status_string = item.status === STATUS_CODE.Disabled ? 'disable' : item.status === STATUS_CODE.Draft ? 'draft' : item.status === STATUS_CODE.Draft ? 'schedule' : 'active';
      item.from_table = true;
    });
    productData.value = res.data.data.data;

    sort.value.total_page = res.data.data.last_page;

    let isNoFilter = params.value.status === '' && sort.value.search_keyword === '';
    if (isNoFilter && productData.value.length === 0) {
      emit('isProductEmpty', true);
    } else {
      emit('isProductEmpty', false);
    }
  } catch (err) {
    console.error(err);
  } finally {
    loading.value = false;
  }


};

const search = (keyword) => {
  sort.value.sort_key = '';
  sort.value.sort_val = 'desc';
  sort.value.search_keyword = keyword;
  fetchData();
};

const pickStatus = (index) => {
  statusList.value.forEach((item, idx) => {
    item.is_selected = idx === index;
  });
  params.value.status = statusList.value[index].keyword;
  fetchData();
};

const updatePagenum = (obj) => {
  sort.value.per_page = obj.id;
  sort.value.page = 1;
  fetchData();
};

const gotoPage = (page) => {
  sort.value.current_page = page;
  sort.value.page = page;
  fetchData();
};

const updateFilter = (obj) => {
  params.value = obj;
  fetchData();
};

const sortFun = (key) => {
  if (key === sort.value.sort_key) {
    sort.value.sort_val = sort.value.sort_val === 'asc' ? 'desc' : 'asc';
  } else {
    sort.value.sort_key = key;
    sort.value.sort_val = 'asc';
  }
  sort.value.page = 1;
  fetchData();
};

const toggleAll = () => {
  checkAll.value = !checkAll.value;
  productData.value.forEach(item => {
    if (item.canClick) {
      item.checked = checkAll.value;
    }
  });

};

const checkHandle = (row, index) => {
  if (!row.canClick) {
    row.checked = false;
  } else {
    row.checked = !row.checked;
  }
  // 判斷能點擊的是否全選
  const canClickItems = productData.value.filter(item => item.canClick);
  checkAll.value = canClickItems.length > 0 && canClickItems.every(item => item.checked);
};



const pickEdit = (row, key) => {
  //same in collection
  // Draft: Edit, Publish, Delete
  // Active: Disable, Feature/Unfeature
  // Scheduled: Edit, Publish, Disable
  // Disabled: Edit, Reactivate
  if (row.status === STATUS_CODE.Draft) {
    editList.value = [
      DROP_LIST.Edit,
      DROP_LIST.Publish,
      DROP_LIST.Delete
    ];
  } else if (row.status === STATUS_CODE.Disabled) {
    editList.value = [
      DROP_LIST.Edit,
      DROP_LIST.ReActive,
    ];
  } else if (row.status === STATUS_CODE.Scheduled) {
    editList.value = [
      DROP_LIST.Edit,
      DROP_LIST.Publish,
      DROP_LIST.Disabled,
    ];
  } else if (row.status === STATUS_CODE.Active) {
    if(row.is_feature){
      editList.value = [
        DROP_LIST.Edit,
        DROP_LIST.UnFeature,
        DROP_LIST.Disabled,
      ]
    }else{
      editList.value = [
        DROP_LIST.Edit,
        DROP_LIST.Feature,
        DROP_LIST.Disabled,
      ];
    }

  }

  //-------permission

  //----------------

  editValue.value = now_pick_key.value === key && editValue.value ? false : true;//控制開關
  now_pick_row.value = row;
  now_pick_key.value = key;

  if (key <= 3) {
    editListTop.value = 32;
    editListTopText.value = `top:${editListTop.value}px`;
  } else {
    editListTop.value = 20;
    editListTopText.value = `bottom:${editListTop.value}px`;
  }

};

const handleClick = (e) => {
  const elements = el.value;
  let isOutside = true;

  // $refs.el v-for 
  if (Array.isArray(elements)) {
    for (let el of elements) {
      if (el.contains(e.target)) {
        isOutside = false;
        break;
      }
    }
  }

  if (isOutside) {
    editValue.value = false;
  }
};

const selectType = (id, index) => {
  editValue.value = false;
  const aId = now_pick_row.value.id;

  switch (id) {
    case 1:
      // Use the pre-processed product data directly
      const productToEdit = {
        ...now_pick_row.value,
        is_edit: true
      };

      // console.log(now_pick_row.value)
      // editProduct(now_pick_row.value);
      edit_product_variants_el.value.open(productToEdit);
      break;

    case 2:
      // feature
      eventBus.emit('open-storefront-product-handle-dialog', {
        type: 'Feature',
        data: [now_pick_row.value]
      });
      break;

    case 6:
      // diasbled
      eventBus.emit('open-storefront-product-handle-dialog', {
        type: 'Disabled',
        data: [now_pick_row.value]
      });
      break;

    case 7:
      // unfeatuer
      eventBus.emit('open-storefront-product-handle-dialog', {
        type: 'Unfeature',
        data: [now_pick_row.value]
      });
      break;

    case 8:
      // publish
      eventBus.emit('open-storefront-product-handle-dialog', {
        type: now_pick_row.value.status === STATUS_CODE.Scheduled  ? 'PublishSchedule' : now_pick_row.value.status === STATUS_CODE.Draft && now_pick_row.value.publish_datetime ?'PublishDraftToSchedule':'Publish',
        data: [now_pick_row.value]
      });
      break;
    case 9:
      // delete
      eventBus.emit('open-storefront-product-handle-dialog', {
        type: 'Delete',
        data: [now_pick_row.value]
      });
      break;
    case 10:
      // reactivate
      eventBus.emit('open-storefront-product-handle-dialog', {
        type: now_pick_row.value.status === STATUS_CODE.Scheduled || now_pick_row.value.status === STATUS_CODE.Draft ? 'PublishSchedule' : 'Publish',
        data: [now_pick_row.value]
      });
      break;

    default:
      break;
  }
};

const openBook = async (row) => {
  eventBus.emit('add-products-to-collections', [row.product_data.id]);
};

const openPostTo = async (row) => {
  row.click_all = row.apply_to_all_creators;
  const result = await openRecipientEditDialog(row);
  if (result) {
    await saveRecipitentInTable(result, 'product');
    fetchData();
  }
};

const fetchAllProducts = async () => {
  if (all_product_rows.value.length > 0) return all_product_rows.value;
  const fetchDataInBack = async (page) => {

    const params_data = {
      sort_key: '',
      sort_val: sort.value.sort_val,
      page: page,
      per_page: sort.value.per_page,
      filters: [],
      keyword: '',
    };
    try {
      loading.value = true;
      const res = await ajax(`storefront-curation/get-curation-product-list`, {
        params: params_data,
        method: 'get',
      });
      return {
        rows: res.data.data.data,
        current_page: res.data.data.current_page,
        last_page: res.data.data.last_page,
      };
    } catch (err) {
      console.error(err);
    } 

  };

  let page = 1;
  let last_page = 1;
  try {
    loading.value = true;
    do {
      const { rows, current_page, last_page: lp } = await fetchDataInBack(page);
      all_product_rows.value.push(...rows);
      last_page = lp;
      page++;
    } while (page <= last_page);
  } finally {
    loading.value = false;
  }

  return all_product_rows.value;
};
//++++++++
//++++++++++++++++++++++++
onMounted(async () => {
  fetchData();
  window.addEventListener('click', handleClick);
  eventBus.on('refresh-storefront-product-table', () => {
    fetchData();
  });
  eventBus.on('request-all-products', async (callback) => {
    const rows = await fetchAllProducts();
    // result callback to paparnt
    callback(rows);
  });
});

onBeforeUnmount(() => {
  window.removeEventListener('click', handleClick);
  eventBus.off('refresh-storefront-product-table');
  eventBus.off('request-all-products');
});

</script>
<style lang="scss">
#product-data-wrap {
  .coll-td {
    display: flex;
    align-items: center;
    gap: 8px;

    svg {
      width: 12px;
      height: 12px;
    }
  }

  th .sort{
    display: flex !important;
  }

  .collect-name {
    font: var(--medium-16);
    color: var(--Text-primary);
    overflow: hidden;
    text-overflow: ellipsis;
    white-space: nowrap;
    margin-bottom: 4px;
  }

  .desc {
    font: var(--medium-14);
    color: var(--Text-primary);
  }

  .bottom {
    font: var(--medium-14);
    color: var(--Text-primary);
    margin-top: 8px;
  }

  .user-name,
  .date-text {
    margin: 0;
    line-height: 20px;
  }

  .status-td .flex {
    display: flex;
    flex-wrap: wrap;
    gap: 4px;
    margin-bottom: 4px;
  }

  .variants-td {
    span {
      white-space: nowrap;
      display: block;
    }
  }

}
</style>